import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getStorageItem } from "../../utils/sessionStorage";
import logo from "../../assets/img/logo/buddha.png";
import { API } from "../../utils/axios";

export default function Success() {
  const navigate = useNavigate();

  const backgroundLogoStyle: React.CSSProperties = {
    backgroundImage: `url(${logo})`,
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    backgroundSize: "24%",
  };

  useEffect(() => {
    const fetchSessionDetails = async () => {
      const session_id = getStorageItem("paySessionId");
      const business_email = getStorageItem("business_email");
      const business_id = getStorageItem("business_id");

      

      try {
        const sessionResponse = await API.post("/stripe/session-details", {
          session_id,
          pay_status: "Success",
          business_email,
          business_id,
        });
      } catch (err) {
        console.error("Payment failed", err);
      }
    };

    fetchSessionDetails();
  }, []);

  return (
    <div className="flex flex-col items-center min-h-screen  text-gray-800 px-4">
      <div
        className="absolute !top-[-80px] left-0 right-0 bottom-0 z-0 opacity-5 pointer-events-none"
        style={backgroundLogoStyle}
      ></div>
      <div className="bg-white lg:p-8 lg:max-w-3xl w-full text-center animate-fadeIn mt-5 lg:mt-20">
        <h1 className="text-2xl font-bold mb-2">
          Payment Successful{" "}
          <span className="text-green-600 text-4xl mx-1">✓</span>
        </h1>
        <p className="mb-4 text-lg">
          Your background check fee has been processed.
        </p>
        <p className="mb-4">
          Check your email for a secure link to complete your background check
          (and spam folder, just in case).
        </p>
        <p className="mb-4">
          Thank you for joining LastMinuteWellness!
          <br />
        </p>
        <p className="mb-4">
          We can’t wait to help you start filling your empty spots with new
          clients!
        </p>
        <p className="mb-2">
          Questions? Email us at
          <a
            href="mailto:info@lastminutewellness.ca"
            className="ml-2 border-b-2 cursor-pointer border-blue-600 text-blue-600 text-base"
          >
            info@lastminutewellness.ca
          </a>
        </p>
      </div>
    </div>
  );
}
